import { useState, useEffect } from "react";
import DateTimePicker, { DateRange } from "./DatePicker/DateTimePicker";

type CalendarProps = {
  onDateRangeChange: (dateRange: DateRange) => void;
  dateRange?: DateRange;
};

const Calendar: React.FC<CalendarProps> = ({
  onDateRangeChange,
  dateRange: externalDateRange,
}) => {
  const [dateRange, setDateRange] = useState<DateRange>({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    if (
      externalDateRange &&
      (externalDateRange.startDate || externalDateRange.endDate)
    ) {
      setDateRange(externalDateRange);
    }
  }, [externalDateRange]);

  const handleDateRangeChange = (newDateRange: DateRange) => {
    setDateRange(newDateRange);
    onDateRangeChange(newDateRange);
  };

  const handleClearSelection = () => {
    setDateRange({ startDate: null, endDate: null });
    onDateRangeChange({ startDate: null, endDate: null });
  };

  return (
    <div className="flex flex-row items-stretch w-full gap-2 border border-blue-200 rounded-md focus:border-blue-200">
      <div className="w-full">
        <DateTimePicker
          id="calendar-dtp"
          onDateRangeChange={handleDateRangeChange}
          onClearSelection={handleClearSelection}
          initialDateRange={dateRange}
          placement="bottom-end"
          handlerWidth="100%"
        />
      </div>
    </div>
  );
};

export default Calendar;
